import { useHotel } from "@/context/HotelContext";

export const useStrictHotel = (local) => {
  const { hotelId, hotels } = useHotel();
  return hotelId !== "all" ? hotelId : local || hotels[0]?.id;
};

export const HotelSegment = ({ value, onChange }) => {
  const { hotelId, hotels } = useHotel();
  if (hotelId !== "all") return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="hotel-segment">
      {hotels.map((h) => (
        <button key={h.id} onClick={() => onChange(h.id)} data-testid={`hotel-segment-${h.id}`}
          className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${value === h.id ? "bg-amber-600 text-white border-amber-500" : "border-slate-300 text-slate-700 hover:border-slate-400"}`}>
          {h.name}
        </button>
      ))}
    </div>
  );
};
